import React from 'react';

import { flagStyles } from '../settings';

const SvgDZ = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-1440px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgDZ;
